import en from './lang-en.json';
import cs from './lang-cs.json';

export const translations: Record<string, Record<string, string>> = {
  en,
  cs,
};

export const langList = ['en', 'cs'];

export function getLang(key: string): string {
  const savedLang = localStorage.getItem('lang') || langList[0];
  return translations[savedLang]?.[key] || translations.en?.[key] || key;
}
